// removed by extract-text-webpack-plugin
module.exports = {"button":"Yta9GfKtpN5QGyJoG65_b","text":"_2qvyswyGWK0iBK5chO2Kx5","buttonDisabled":"_3xQsd15fblb2JVH3nHWjo4 Yta9GfKtpN5QGyJoG65_b","icon":"_2NM1HL7GnVVmid7lT0aLem"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/button/Button.styl
// module id = 730
// module chunks = 0